var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "79px",
    viewBox: "0 0 90 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Center",
    transform: "translate(-611.000000, -1341.000000)",
    stroke: "#373633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "analytics",
    transform: "translate(611.000000, 794.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-315.020328,726.197145 C-266.629034,724.330906 -229.435968,704.155356 -203.441129,665.670492 C-164.44887,607.943198 -22.0817841,620.253473 40.979672,637.804297",
    id: "Path-2",
    strokeWidth: 0.8,
    strokeDasharray: 6,
    transform: "translate(-137.020328, 674.697145) scale(-1, 1) rotate(-322.000000) translate(137.020328, -674.697145) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "fly",
    transform: "translate(62.979672, 582.697145) rotate(346.000000) translate(-62.979672, -582.697145) translate(28.979672, 555.197145)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "18.3779674 31.7714292 26.0129361 55 68 0 0 15.4062921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.597561,32.4107143 L66.402439,0.589285714",
    id: "Line-3",
    strokeLinecap: "square",
    strokeDasharray: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.39051584445c0e91306588bb4642a69e.svg";
export { ForwardRef as ReactComponent };